// polyfills
import 'classlist-polyfill';
import 'core-js/es6/object';
import 'core-js/es6/array';
import 'core-js/es6/number';
import 'core-js/es6/promise';
import 'core-js/es7/object';
import 'core-js/es7/array';

import wrapper from 'wrapper';
import Gallery from './components/gallery/gallery';

class App {
    constructor() {
        this.gallery = new Gallery(wrapper.select('#gallery'), {
            interval: 2000,
            buffer: 6000,
        });
        this.gallery
            .withNavButtons()
            .withPlaybackButton()
            .withProgress()
            .withAutoplay();

        wrapper.selectAll('.no-js')
            .forEach(e => e.classList.remove('no-js'));
    }
}

new App();
wrapper.markPageAsLoaded();
